import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, FlexBox, Tag, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { useState } from 'react';
import styles from './conversationPreviewTags.module.scss';
export const ConversationPreviewTags = ({ tags, scrollable = false, className, showSectionIcon, }) => {
    const numberOfTagsToShowInitially = 10;
    const numberOfTags = tags === null || tags === void 0 ? void 0 : tags.length;
    const showToggleButton = numberOfTagsToShowInitially < numberOfTags;
    const [showAllTags, setShowAllTags] = useState(false);
    const rootClass = classnames(styles.root, {
        [styles.rootScrollable]: scrollable,
    }, className);
    const toggleShowAll = () => {
        setShowAllTags(!showAllTags);
    };
    const tagsToRender = tags.slice(0, showAllTags ? numberOfTags : numberOfTagsToShowInitially);
    const numberOfTagsLeftToRender = numberOfTags - tagsToRender.length;
    const buttonLabel = !showAllTags
        ? `+ ${numberOfTagsLeftToRender} more`
        : `Show less`;
    if (!numberOfTags) {
        return null;
    }
    return (_jsxs(FlexBox, Object.assign({ className: rootClass, flexDirection: "row", gap: "200", alignItems: "center" }, { children: [showSectionIcon && (_jsx(Tooltip, Object.assign({ content: "Tags", dark: true }, { children: _jsx(Avatar, { className: styles.icon, icon: "tag", color: {
                        contentColor: colors.neutral[700],
                        backgroundColor: colors.neutral[100],
                    } }) }))), _jsx(FlexBox, Object.assign({ alignItems: "center", gap: "200", flexWrap: scrollable ? 'nowrap' : 'wrap' }, { children: tagsToRender.map((tag) => {
                    const isTruncated = tag.name.length > 17;
                    return (_jsx(Tooltip, Object.assign({ content: tag.name, disabled: !isTruncated, dark: true }, { children: _jsx(Tag, Object.assign({ color: tag.color, className: styles.tag, disabled: tag.is_deactivated }, { children: tag.name })) }), tag.id));
                }) })), showToggleButton && (_jsx(Button, Object.assign({ variant: "tertiary", onClick: toggleShowAll }, { children: buttonLabel })))] })));
};
